import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useGetMe from "../hooks/useCurrentUser";
import { IAppState } from "../store/types";
import { readSelectedCompany } from "../global/companies";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";

import AuthLayout from "../components/AuthLayout";
import AuthGatePessoaFisica from "../components/AuthGatePessoaFisica";
import AuthGatePessoaJuridica from "../components/AuthGatePessoaJuridica";
import AuthGateAdmin from "../components/AuthGateAdmin";
import AuthGateContaSplit from "../components/AuthGateContaSplit";
import AuthGateComercial from "../components/AuthGateComercial";
import AuthGateAntecipadora from "../components/AuthGateAntecipadora";
import AuthGateParceiro from "../components/AuthGateParceiro";
import PrivateRoute from "../components/PrivateRoute";
import Dashboard from "../pages/dashboard";
import SignIn from "../pages/signIn";
import signInAdmin from "../pages/signinAdmin";
import PageWrapperPessoaFisica from "../components/PageWrapperPessoaFisica";
import PageWrapperPessoaJuridica from "../components/PageWrapperPessoaJuridica";
import PageWrapperAdmin from "../components/PageWrapperAdmin";
import PageWrapperComercial from "../components/PageWrapperComercial";
import PageWrapperParceiro from "../components/PageWrapperParceiro";
import PageWrapperContaSplit from "../components/PageWrapperContaSplit";
import NotFound from "../pages/NotFound";
import Veiculos from "../pages/veiculos";
import ConsultaSolicitacoes from "../pages/DebitosVeiculares/consultaSolicitacoes/list";
import ConsultaDebitos from "../pages/DebitosVeiculares/ConsultaDebitos";
import ConsultaMultasRenainf from "../pages/DebitosVeiculares/consultaMultasRenainf";
import ForgotPassword from "../pages/forgotPassword";
import ResetPassword from "../pages/resetPassword";
import PoliticaPrivacidade from "../pages/privacyPolicy";
import CadastrarConsulta from "../pages/antecipacao/cadastrarConsulta";
import UnidadesRecebiveis from "../pages/cerc/unidadesRecebiveis";
import ResetPasswordApp from "../pages/resetPasswordApp";
import Usuarios from "../pages/usuarios";
import TransacoesNossaCidade from "../pages/transacoesNossaCidade";
import Cancellations from "../pages/creditCard/cancellation";
import Chargeback from "../pages/creditCard/chargeback";
import Adiantamentos from "../pages/adiantamentosNossaCidade/adiantamentos";
import NotaPromissoria from "../pages/notaPromissoria";
import Credenciais from "../pages/credenciais";
import Business from "../pages/business";
import { RoutesEnum } from "./types";
import Detalhes from "../pages/transacoesErepasses/details";
import BoletoCnab from "../pages/boletoRendimento/gerarBoletoCnab";
import ListaBoletos from "../pages/boletoRendimento/boletos";
import TransacaoTempoReal from "../pages/transacoesErepasses/transacaoTempoReal";
import Adjustment from "../pages/transacoesErepasses/adjustments";
import Repasses from "../pages/transacoesErepasses/repasses";
import DetalhesRepasses from "../pages/transacoesErepasses/detalhesRepasses";
import TransferenciasRepasses from "../pages/transacoesErepasses/transferenciasDeRepasses";
import CarteiraVirtual from "../pages/carteiraVirtual";
import CreatePoliticaCobranca from "../pages/politicaCobranca/create";
import ListPoliticaCobranca from "../pages/politicaCobranca/list";
import UpdatePoliticaCobranca from "../pages/politicaCobranca/update";
import PoliticaContaDigitalList from "../pages/politicaContaDigital/list";
import PoliticaContaDigitalCreate from "../pages/politicaContaDigital/create";
import PoliticaContaDigitalUpdate from "../pages/politicaContaDigital/update";
import ListaEmpresa from "../pages/listaEmpresas";
import Arranjos from "../pages/arranjos/arranjos";
import useCurrentBusiness from "../hooks/useCurrentBusiness";
import PixCopiaECola from "../pages/pix/copiaECola";
import PoliticaCobrancaEmpresa from "../pages/politicaCobranca/list/components/business";
import PixPagamentos from "../pages/pix/pagamento";
import Extrato from "../pages/contaDigital/extrato";
import BoletoPagamento from "../pages/boletoRendimento/pagamento";
import Trava from "../pages/contaEscrow/trava/trava";
import PageWrapperAntecipadora from "../components/PageWrapperAntecipadora";
import CargaCartao from "../pages/cargaCartao/pagamento";
import ExtratoCartao from "../pages/cargaCartao/extrato/extratoCartao";
import CartaoProxy from "../pages/cartaoProxy/cartaoProxy";
import MeuPerfil from "../pages/meuPerfil";
import ContratoEscrow from "../pages/contratoEscrow";
import PainelDeVendas from "../pages/transacoesErepasses/painelDeVendas";
import PainelDeRecebiveis from "../pages/transacoesErepasses/painelDeRecebiveis";
import PainelDePagamentos from "../pages/transacoesErepasses/painelDePagamentos";
import PainelDeCancelamentos from "../pages/painelDeCancelamento/cancelamentoDeTransacoes/painelDeCancelamentos";
import SimuladorVenda from "../pages/simuladores/simuladorVenda";
import SimuladorRecebimento from "../pages/simuladores/simuladorRecebimento";
import DetalhamentoPagamentosSLC from "../pages/detalhamentoSLC/pagamentos";
import LiquidacoesFalhasSLC from "../pages/detalhamentoSLC/liquidacoesFalhas";
import DashboardComercial from "../pages/dashboardComercial";
import ListarLinks from "../pages/linkDePagamento/listar-links/listar-links";
import CadastrarLinks from "../pages/linkDePagamento/cadastrar-links/cadastrar-links";
import ListarAssinaturas from "../pages/linkDeAssinatura/listar-links/listar-assinaturas";
import CadastrarAssinaturas from "../pages/linkDeAssinatura/cadastrar-links/cadastrar-assinaturas";
import DetalhesEdi from "../pages/adiqEdi/detalhesEdi";
import GerenciadorEdi from "../pages/adiqEdi/gerenciadorEdi";
import TerminaisPhoebus from "../pages/terminaisPhoebus";
import HistoricoDeCancelamentos from "../pages/painelDeCancelamento/historicoDeCancelamento";
import LoginCancelamento from "../pages/painelDeCancelamento/loginCancelamento";
import PainelDeDepositos from "../pages/transacoesErepasses/painelDeDepositos/painelDeDepositos";
import BillingPanel from "../pages/billingMenu/billingPanel/billingPanel";
import Signatures from "../pages/billingMenu/signatures/signaturesMenu/signatures";
import LoginRecebiveis from "../pages/detalhamentoLiquidacao/loginRecebiveis/loginRecebiveis";
import Recebiveis from "../pages/detalhamentoLiquidacao/recebiveis/recebiveis";
import LoginSignatures from "../pages/billingMenu/signatures/loginSignatures/loginSignatures";
import LoginVendas from "../pages/detalhamentoLiquidacao/loginVendas/loginVendas";
import Vendas from "../pages/vendas";
import DetLiqVendas from "../pages/detalhamentoLiquidacao/vendas/vendas";
import LoginAnticipation from "../pages/billingMenu/punctualAnticipation/loginAnticipation/loginAnticipation";
import Anticipation from "../pages/billingMenu/punctualAnticipation/anticipation/anticipation";
import AnticipationHistory from "../pages/billingMenu/punctualAnticipation/anticipationHistory/anticipationHistory";
import EfeitoDeContrato from "../pages/transacoesErepasses/efeitoDeContrato";
import ContractEffects from "../pages/contractEffects/effectsFulfilled/contractEffects";
import ContractEffectsQuery from "../pages/contractEffects/effectsQuery/contractEffectsQuery";
import LoginAnticipationFee from "../pages/billingMenu/anticipationFees/loginAnticipationFeeMenu/loginAnticipationFee";
import AnticipationFee from "../pages/billingMenu/anticipationFees/anticipationFeeMenu/anticipationFee";
import TransactionAnticipationHistoryPage from "../pages/billingMenu/punctualAnticipation/transactionAnticipationHistory/transactionAnticipationHistoryPage";
import PaymentStatement from "../pages/paymentStatement";
import Fees from "../pages/fees";
import Contracts from "../pages/contracts";
import ContractsHistory from "../pages/contracts/history";
import LoginChargeback from "../pages/billingMenu/chargeback/loginChargeback/loginChargeback";
import Chageback from "../pages/billingMenu/chargeback/chargeback";
import Creditors from "../pages/contractEffects/creditors/creditors";
import SingleCharge from "../pages/billingMenu/singleCharge/singleCharge";
import LoginSingleCharge from "../pages/billingMenu/singleCharge/loginSingleCharge/loginSingleCharge";
import Reprocessamento from "../pages/transacoesErepasses/reprocessamento";
import PesquisaNps from "../pages/pesquisaNps";

const Routes: React.FC = () => {
  const currentBusiness = useCurrentBusiness();
  const selectedBusiness = readSelectedCompany();
  const [business, setBusiness] = useState<boolean>(false);
  const currentUser = useGetMe();
  const isAuthenticated = useSelector((state: IAppState) => state.user.isAuthenticated);
  const userType = isAuthenticated ? currentUser?.userType : undefined;

  useEffect(() => {
    const handleBusiness = () => {
      if (selectedBusiness == null) {
        setBusiness(true);
      } else {
        setBusiness(false);
      }
    };
    handleBusiness();
  }, [selectedBusiness]);
  return (
    <Router>
      <Switch>
        <Route exact path="/login" component={SignIn} />
        <Route exact path="/login/suporte/:email" component={signInAdmin} />
        <Route exact path="/esqueci-minha-senha" component={ForgotPassword} />
        <Route exact path="/redefinir-senha" component={ResetPassword} />
        <Route
          exact
          path="/politica-privacidade"
          component={PoliticaPrivacidade}
        />
        <Route exact path="/reset-password-app" component={ResetPasswordApp} />
        <Route path="/">
          <AuthLayout>
            {!isAuthenticated && <Redirect to="/login" />}
            {userType === 1 && <AuthGatePessoaFisica>
              {/* Escolher empresa não é privilégio da PJ: o login já resolve quem
                  tem uma só, e quem tem mais de uma passa por aqui. Antes o PF era
                  jogado na primeira da lista, sem esta tela e sem seletor. */}
              {business && (
                <>
                  <PrivateRoute exact path="/">
                    <Redirect to="/lista-empresa" />
                  </PrivateRoute>
                  <PrivateRoute
                    exact
                    path="/lista-empresa"
                    component={ListaEmpresa}
                  />
                </>
              )}
              {!business && (
              <Contracts>
                <PageWrapperPessoaFisica>
                  <PrivateRoute exact path="/lista-empresa">
                    <Redirect to="/painel-de-vendas" />
                  </PrivateRoute>
                  <PrivateRoute exact path="/">
                    <Redirect to="/painel-de-vendas" />
                  </PrivateRoute>
                  <PrivateRoute
                    exact
                    path="/painel-de-vendas"
                    component={PainelDeVendas}
                  />
                  <PrivateRoute
                    exact
                    path="/painel-de-recebiveis"
                    component={PainelDeRecebiveis}
                  />
                  <PrivateRoute exact path="/meu-perfil" component={MeuPerfil} />
                  <PrivateRoute
                    exact
                    path="/simulador/venda"
                    component={SimuladorVenda}
                  />
                  <PrivateRoute
                    exact
                    path="/simulador/recebimento"
                    component={SimuladorRecebimento}
                  />
                  <PrivateRoute
                    exact
                    path="/menu-cobrancas"
                    component={BillingPanel}
                  />
                  <PrivateRoute exact path="/produtos" component={Signatures} />
                  <PrivateRoute exact path="/assinaturas" component={Signatures} />
                  <PrivateRoute exact path="/cobranca-avulsa" component={SingleCharge} />


                  {selectedBusiness?.allowPaymentLink && (
                    <>
                      <PrivateRoute
                        exact
                        path="/listar-links"
                        component={ListarLinks}
                      />
                      <PrivateRoute
                        exact
                        path="/cadastrar-links"
                        component={CadastrarLinks}
                      />
                    </>
                  )}
                  {selectedBusiness?.allowPaymentLink && (
                    <>
                      <PrivateRoute
                        exact
                        path="/listar-assinaturas"
                        component={ListarAssinaturas}
                      />
                      <PrivateRoute
                        exact
                        path="/cadastrar-assinaturas"
                        component={CadastrarAssinaturas}
                      />
                    </>
                  )}

                  <PrivateRoute
                    exact
                    path="/admin/efeito-contrato"
                    component={ContractEffects}
                  />

                  <PrivateRoute
                    exact
                    path="/admin/historico-antecipacao"
                    component={AnticipationHistory}
                  />

                <PrivateRoute
                  exact
                  path="/transacao-historico-antecipacao/:historyAnticipationId"
                  component={TransactionAnticipationHistoryPage}
                />
                <PrivateRoute
                  exact
                  path="/admin/chargeback"
                  component={Chageback}
                />

                  <PrivateRoute
                    exact
                    path="/extrato"
                    component={PaymentStatement}
                  />

                  <PrivateRoute
                    exact
                    path="/fees"
                    component={Fees}
                  />

                  <PrivateRoute
                    exact
                    path="/contracts-history"
                    component={ContractsHistory}
                  />

                </PageWrapperPessoaFisica>
              </Contracts>
              )}
            </AuthGatePessoaFisica>}

            {userType === 2 && <AuthGatePessoaJuridica>
              {business && (
                <>
                  <PrivateRoute exact path="/">
                    <Redirect to="/lista-empresa" />
                  </PrivateRoute>
                  <PrivateRoute
                    exact
                    path="/lista-empresa"
                    component={ListaEmpresa}
                  />
                </>
              )}
              {!business && (
                <Contracts>
                  <PageWrapperPessoaJuridica>
                    <PrivateRoute exact path="/lista-empresa">
                      <Redirect to="/painel-de-vendas" />
                    </PrivateRoute>
                    <PrivateRoute exact path="/">
                      <Redirect to="/painel-de-vendas" />
                    </PrivateRoute>
                    {selectedBusiness?.allowPaymentLink && (
                      <>
                        <PrivateRoute
                          exact
                          path="/listar-links"
                          component={ListarLinks}
                        />
                        <PrivateRoute
                          exact
                          path="/cadastrar-links"
                          component={CadastrarLinks}
                        />
                      </>
                    )}
                    {selectedBusiness?.allowPaymentLink && (
                      <>
                        <PrivateRoute
                          exact
                          path="/listar-assinaturas"
                          component={ListarAssinaturas}
                        />
                        <PrivateRoute
                          exact
                          path="/cadastrar-assinaturas"
                          component={CadastrarAssinaturas}
                        />
                      </>
                    )}
                    <PrivateRoute
                      exact
                      path="/transacoes-tempo-real"
                      component={TransacaoTempoReal}
                    />
                    <PrivateRoute
                      exact
                      path="/transacoes-repasse"
                      component={Detalhes}
                    />
                    <PrivateRoute
                      exact
                      path={`${RoutesEnum.UnidadesRecebiveis}/:solcitacaoConsultaId`}
                      component={UnidadesRecebiveis}
                    />
                    <PrivateRoute
                      exact
                      path="/painel-de-vendas"
                      component={PainelDeVendas}
                    />
                    <PrivateRoute
                      exact
                      path="/painel-de-recebiveis"
                      component={PainelDeRecebiveis}
                    />
                    <PrivateRoute
                      exact
                      path="/painel-de-efeitos"
                      component={EfeitoDeContrato}
                    />
                    <PrivateRoute exact path="/meu-perfil" component={MeuPerfil} />
                    <PrivateRoute
                      exact
                      path="/simulador/venda"
                      component={SimuladorVenda}
                    />
                    <PrivateRoute
                      exact
                      path="/simulador/recebimento"
                      component={SimuladorRecebimento}
                    />
                    <PrivateRoute
                      exact
                      path="/menu-cobrancas"
                      component={BillingPanel}
                    />
                    <PrivateRoute exact path="/produtos" component={Signatures} />
                    <PrivateRoute exact path="/cobranca-avulsa" component={SingleCharge} />
                    <PrivateRoute
                      exact
                      path="/assinaturas"
                      component={Signatures}
                    />
                    ;
                    <PrivateRoute
                      exact
                      path="/admin/efeito-contrato"
                      component={ContractEffects}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/historico-antecipacao"
                      component={AnticipationHistory}
                    />

                    <PrivateRoute
                      exact
                      path="/transacao-historico-antecipacao/:historyAnticipationId"
                      component={TransactionAnticipationHistoryPage}
                    />

                    <PrivateRoute
                      exact
                      path="/extrato"
                      component={PaymentStatement}
                    />

                    <PrivateRoute
                      exact
                      path="/fees"
                      component={Fees}/>

                    <PrivateRoute
                      exact
                      path="/contracts-history"
                      component={ContractsHistory}
                    />

                    <PrivateRoute
                      exact
                      path="/admin/chargeback"
                      component={Chageback}
                    />
                  </PageWrapperPessoaJuridica>
                </Contracts>

              )}
            </AuthGatePessoaJuridica>}

            {userType === 4 && <AuthGateAntecipadora>
              <PageWrapperAntecipadora>
                <PrivateRoute exact path="/">
                  <Redirect to="/tecpay/admin/painel-de-vendas" />
                </PrivateRoute>
                <PrivateRoute exact path="/dashboard" component={Dashboard} />
                <PrivateRoute exact path="/veiculos" component={Veiculos} />
                <PrivateRoute exact path="/arranjos" component={Arranjos} />
                <PrivateRoute
                  exact
                  path="/debitos-veiculares/pagamentos"
                  component={ConsultaSolicitacoes}
                />
                <PrivateRoute
                  exact
                  path="/debitos-veiculares/debitos"
                  component={ConsultaDebitos}
                />
                <PrivateRoute
                  exact
                  path="/debitos-veiculares/multas-renainf"
                  component={ConsultaMultasRenainf}
                />
                <PrivateRoute exact path="/boletos" component={ListaBoletos} />
                <PrivateRoute
                  exact
                  path="/boletos/pagamentos"
                  component={BoletoPagamento}
                />
                <PrivateRoute
                  exact
                  path="/boletos/gerar-boleto/cnab"
                  component={BoletoCnab}
                />
                <PrivateRoute
                  exact
                  path="/consultas/cadastrar-consulta"
                  component={CadastrarConsulta}
                />
                {/* <PrivateRoute exact path="/usuarios/usuarios-vinculados" component={UsuariosAntecipadoras} /> */}
                {/* <PrivateRoute exact path="/repasses" component={Repasses} /> */}
                {/* <PrivateRoute exact path="/repasses/detalhes" component={DetalhesRepasses} /> */}
                <PrivateRoute
                  exact
                  path="/transacoes-tempo-real"
                  component={TransacaoTempoReal}
                />
                <PrivateRoute
                  exact
                  path="/transacoes-repasse"
                  component={Detalhes}
                />
                <PrivateRoute
                  exact
                  path="/tecpay/admin/repasses"
                  component={Repasses}
                />
                <PrivateRoute
                  exact
                  path="/tecpay/admin/repasses/detalhes"
                  component={DetalhesRepasses}
                />
                <PrivateRoute
                  exact
                  path="/tecpay/admin/repasses/transferencias"
                  component={TransferenciasRepasses}
                />
                <PrivateRoute
                  exact
                  path="/tecpay/admin/painel-de-vendas"
                  component={PainelDeVendas}
                />
                <PrivateRoute
                  exact
                  path="/tecpay/admin/painel-de-recebiveis"
                  component={PainelDeRecebiveis}
                />
                <PrivateRoute
                  exact
                  path="/tecpay/admin/carteira-virtual"
                  component={CarteiraVirtual}
                />
                <PrivateRoute
                  exact
                  path={`${RoutesEnum.UnidadesRecebiveis}/:solcitacaoConsultaId`}
                  component={UnidadesRecebiveis}
                />
                <PrivateRoute
                  exact
                  path="/pix/copia-e-cola"
                  component={PixCopiaECola}
                />
                <PrivateRoute
                  exact
                  path="/pix/pagamentos"
                  component={PixPagamentos}
                />
                <PrivateRoute
                  exact
                  path="/conta-digital/extrato"
                  component={Extrato}
                />
                <PrivateRoute
                  exact
                  path="/conta-escrow-trava"
                  component={Trava}
                />
                <PrivateRoute exact path="/meu-perfil" component={MeuPerfil} />
                <PrivateRoute
                  exact
                  path="/contrato-escrow"
                  component={ContratoEscrow}
                />
              </PageWrapperAntecipadora>
            </AuthGateAntecipadora>}

            {userType === 3 && <AuthGateAdmin>
              <PageWrapperAdmin>
                <PrivateRoute exact path="/">
                  <Redirect to="/admin/painel-de-vendas" />
                </PrivateRoute>
                <PrivateRoute exact path="/dashboard" component={Dashboard} />
                <PrivateRoute
                  exact
                  path="/comercial/dashboard"
                  component={DashboardComercial}
                />
                <PrivateRoute exact path="/admin/usuarios" component={Usuarios} />
                <PrivateRoute
                  exact
                  path="/admin/pesquisa-nps"
                  component={PesquisaNps}
                />
                <PrivateRoute
                  exact
                  path="/admin/transacoes-nossa-cidade"
                  component={TransacoesNossaCidade}
                />
                <PrivateRoute
                  exact
                  path="/admin/cancelamentos"
                  component={Cancellations}
                />
                <PrivateRoute
                  exact
                  path="/admin/chargebacks"
                  component={Chargeback}
                />
                <PrivateRoute exact path="/admin/vendas" component={Vendas} />
                <PrivateRoute
                  exact
                  path="/admin/notaPromissoria"
                  component={NotaPromissoria}
                />
                <PrivateRoute exact path="/veiculos" component={Veiculos} />
                <PrivateRoute exact path="/arranjos" component={Arranjos} />
                <PrivateRoute
                  exact
                  path="/debitos-veiculares/pagamentos"
                  component={ConsultaSolicitacoes}
                />
                <PrivateRoute
                  exact
                  path="/debitos-veiculares/debitos"
                  component={ConsultaDebitos}
                />
                <PrivateRoute
                  exact
                  path="/debitos-veiculares/multas-renainf"
                  component={ConsultaMultasRenainf}
                />
                <PrivateRoute
                  exact
                  path="/admin/adiantamentos"
                  component={Adiantamentos}
                />
                <PrivateRoute
                  exact
                  path="/admin/credenciais/criar-credencial"
                  component={Credenciais}
                />
                <PrivateRoute exact path="/admin/empresas" component={Business} />
                {/* /admin/vincular-empresa saiu do portal (B6): o vínculo
                    usuário↔empresa é administrado no VAULT. */}
                <PrivateRoute exact path="/boletos" component={ListaBoletos} />
                <PrivateRoute
                  exact
                  path="/boletos/pagamentos"
                  component={BoletoPagamento}
                />
                <PrivateRoute
                  exact
                  path="/boletos/gerar-boleto/cnab"
                  component={BoletoCnab}
                />
                <PrivateRoute
                  exact
                  path="/admin/transacoes-tempo-real"
                  component={TransacaoTempoReal}
                />
                <PrivateRoute
                  exact
                  path="/admin/transacoes-repasse"
                  component={Detalhes}
                />
                <PrivateRoute
                  exact
                  path="/admin/ajustes"
                  component={Adjustment}
                />
                <PrivateRoute
                  exact
                  path="/admin/reprocessamento-transacoes"
                  component={Reprocessamento}
                />
                <PrivateRoute exact path="/admin/repasses" component={Repasses} />
                <PrivateRoute
                  exact
                  path="/admin/repasses/detalhes"
                  component={DetalhesRepasses}
                />
                <PrivateRoute
                  exact
                  path="/admin/repasses/transferencias"
                  component={TransferenciasRepasses}
                />
                <PrivateRoute
                  exact
                  path="/admin/painel-de-vendas"
                  component={PainelDeVendas}
                />
                <PrivateRoute
                  exact
                  path="/admin/painel-de-recebiveis"
                  component={PainelDeRecebiveis}
                />
                <PrivateRoute
                  exact
                  path="/admin/painel-de-pagamentos"
                  component={PainelDePagamentos}
                />
                <PrivateRoute
                  exact
                  path="/admin/painel-de-cancelamentos"
                  component={PainelDeCancelamentos}
                />
                <PrivateRoute
                  exact
                  path="/admin/painel-de-efeitos"
                  component={EfeitoDeContrato}
                />
                <PrivateRoute
                  exact
                  path="/admin/historico-de-cancelamentos"
                  component={HistoricoDeCancelamentos}
                />
                <PrivateRoute
                  exact
                  path="/admin/carteira-virtual"
                  component={CarteiraVirtual}
                />
                <PrivateRoute
                  exact
                  path="/admin/cadastro-geral/politicas-cobranca/cadastrar"
                  component={CreatePoliticaCobranca}
                />
                <PrivateRoute
                  exact
                  path="/admin/cadastro-geral/politicas-cobranca"
                  component={ListPoliticaCobranca}
                />
                <PrivateRoute
                  exact
                  path="/admin/cadastro-geral/politicas-cobranca/editar/:politicaCobrancaId"
                  component={UpdatePoliticaCobranca}
                />
                <PrivateRoute
                  exact
                  path="/pix/copia-e-cola"
                  component={PixCopiaECola}
                />
                <PrivateRoute
                  exact
                  path="/admin/cadastro-geral/politicas-cobranca/business"
                  component={PoliticaCobrancaEmpresa}
                />
                <PrivateRoute
                  exact
                  path="/pix/pagamentos"
                  component={PixPagamentos}
                />
                <PrivateRoute
                  exact
                  path="/conta-digital/extrato"
                  component={Extrato}
                />
                <PrivateRoute
                  exact
                  path="/conta-digital/carga-cartao"
                  component={CargaCartao}
                />
                <PrivateRoute
                  exact
                  path="/conta-digital/extrato-cartao"
                  component={ExtratoCartao}
                />
                <PrivateRoute
                  exact
                  path="/conta-digital/proxy"
                  component={CartaoProxy}
                />
                <PrivateRoute
                  exact
                  path="/contas-digitais/politicas-cobrancas"
                  component={PoliticaContaDigitalList}
                />
                <PrivateRoute
                  exact
                  path="/contas-digitais/politicas-cobrancas/cadastrar"
                  component={PoliticaContaDigitalCreate}
                />
                <PrivateRoute
                  exact
                  path="/contas-digitais/politicas-cobrancas/editar/:politicaCobrancaId"
                  component={PoliticaContaDigitalUpdate}
                />
                <PrivateRoute
                  exact
                  path="/simulador/venda"
                  component={SimuladorVenda}
                />
                <PrivateRoute
                  exact
                  path="/simulador/recebimento"
                  component={SimuladorRecebimento}
                />
                <PrivateRoute
                  exact
                  path="/slc/pagamentos"
                  component={DetalhamentoPagamentosSLC}
                />
                <PrivateRoute
                  exact
                  path="/slc/liquidacoes-falhas"
                  component={LiquidacoesFalhasSLC}
                />
                {/*<PrivateRoute exact path="/terminais" component={Terminais} />*/}
                <PrivateRoute
                  exact
                  path="/terminaisPhoebus"
                  component={TerminaisPhoebus}
                />
                <PrivateRoute
                  exact
                  path="/admin/login-cancelamento"
                  component={LoginCancelamento}
                />
                <PrivateRoute
                  exact
                  path="/admin/detalhes-edi"
                  component={DetalhesEdi}
                />
                <PrivateRoute
                  exact
                  path="/admin/gerenciador-edi"
                  component={GerenciadorEdi}
                />
                <PrivateRoute
                  exact
                  path="/admin/painel-de-depositos"
                  component={PainelDeDepositos}
                />
                <PrivateRoute
                  exact
                  path="/admin/login-recebiveis"
                  component={LoginRecebiveis}
                />
                <PrivateRoute
                  exact
                  path="/admin/detalhe-liquidacao-recebiveis"
                  component={Recebiveis}
                />
                <PrivateRoute
                  exact
                  path="/admin/menu-cobrancas"
                  component={BillingPanel}
                />
                <PrivateRoute
                  exact
                  path="/admin/produtos"
                  component={Signatures}
                />
                <PrivateRoute
                  exact
                  path="/admin/login-assinaturas"
                  component={LoginSignatures}
                />
                <PrivateRoute
                  exact
                  path="/admin/login-vendas"
                  component={LoginVendas}
                />
                <PrivateRoute
                  exact
                  path="/admin/detalhe-liquidacao-vendas"
                  component={DetLiqVendas}
                />
                <PrivateRoute
                  exact
                  path="/admin/login-antecipacao"
                  component={LoginAnticipation}
                />
                <PrivateRoute
                  exact
                  path="/admin/antecipacao-pontual"
                  component={Anticipation}
                />
                <PrivateRoute
                  exact
                  path="/admin/historico-antecipacao"
                  component={AnticipationHistory}
                />
                <PrivateRoute
                  exact
                  path="/transacao-historico-antecipacao/:historyAnticipationId"
                  component={TransactionAnticipationHistoryPage}
                />
                <PrivateRoute
                  exact
                  path="/admin/efeito-contrato"
                  component={ContractEffects}
                />
                <PrivateRoute
                  exact
                  path="/admin/consulta-efeito"
                  component={ContractEffectsQuery}
                />
                <PrivateRoute
                  exact
                  path="/admin/login-cadastrar-taxas-antecipacao"
                  component={LoginAnticipationFee}
                />
                <PrivateRoute
                  exact
                  path="/admin/cadastrar-taxas-antecipacao"
                  component={AnticipationFee}
                />

              <PrivateRoute
                  exact
                  path="/admin/cobranca-avulsa"
                  component={SingleCharge}
                />

                <PrivateRoute
                  exact
                  path="/admin/login-cobranca-avulsa"
                  component={LoginSingleCharge}
                />


                <PrivateRoute
                  exact
                  path="/admin/extrato"
                  component={PaymentStatement}
                />
                <PrivateRoute
                exact
                path="/admin/fees"
                component={Fees}/>
                <PrivateRoute
                  exact
                  path="/admin/contracts-history"
                  component={ContractsHistory}
                />
                <PrivateRoute
                  exact
                  path="/admin/login-chargeback"
                  component={LoginChargeback}
                />
                <PrivateRoute
                  exact
                  path="/admin/chargeback"
                  component={Chageback}
                />
                <PrivateRoute
                  exact
                  path="/admin/cadastro-credor"
                  component={Creditors}
                />
              </PageWrapperAdmin>
            </AuthGateAdmin>}

            {userType === 6 && <AuthGateComercial>
              <PageWrapperComercial>
                <PrivateRoute exact path="/">
                  <Redirect to="/painel-de-vendas" />
                </PrivateRoute>

                <PrivateRoute exact path="/usuarios" component={Usuarios} />
                <PrivateRoute
                  exact
                  path="/cancelamentos"
                  component={Cancellations}
                />
                <PrivateRoute exact path="/chargebacks" component={Chargeback} />
                <PrivateRoute exact path="/vendas" component={Vendas} />
                <PrivateRoute
                  exact
                  path="/notaPromissoria"
                  component={NotaPromissoria}
                />
                <PrivateRoute exact path="/veiculos" component={Veiculos} />
                <PrivateRoute
                  exact
                  path="/adiantamentos"
                  component={Adiantamentos}
                />
                <PrivateRoute
                  exact
                  path="/credenciais/criar-credencial"
                  component={Credenciais}
                />
                <PrivateRoute exact path="/empresas" component={Business} />
                {/* /vincular-empresa saiu do portal (B6): o vínculo
                    usuário↔empresa é administrado no VAULT. */}
                <PrivateRoute
                  exact
                  path="/painel-de-vendas"
                  component={PainelDeVendas}
                />
                <PrivateRoute
                  exact
                  path="/painel-de-recebiveis"
                  component={PainelDeRecebiveis}
                />
                <PrivateRoute
                  exact
                  path="/painel-de-pagamentos"
                  component={PainelDePagamentos}
                />
                <PrivateRoute
                  exact
                  path="/cadastro-geral/politicas-cobranca/cadastrar"
                  component={CreatePoliticaCobranca}
                />
                <PrivateRoute
                  exact
                  path="/cadastro-geral/politicas-cobranca"
                  component={ListPoliticaCobranca}
                />
                <PrivateRoute
                  exact
                  path="/cadastro-geral/politicas-cobranca/editar/:politicaCobrancaId"
                  component={UpdatePoliticaCobranca}
                />

                <PrivateRoute
                  exact
                  path="/admin/cadastro-geral/politicas-cobranca/business"
                  component={PoliticaCobrancaEmpresa}
                />

                <PrivateRoute
                  exact
                  path="/simulador/venda"
                  component={SimuladorVenda}
                />
                <PrivateRoute
                  exact
                  path="/simulador/recebimento"
                  component={SimuladorRecebimento}
                />

                <PrivateRoute
                  exact
                  path="/terminaisPhoebus"
                  component={TerminaisPhoebus}
                />
                <PrivateRoute
                  exact
                  path="/menu-cobrancas"
                  component={BillingPanel}
                />
                <PrivateRoute exact path="/produtos" component={Signatures} />
                <PrivateRoute exact path="/cobranca-avulsa" component={SingleCharge} />
                <PrivateRoute
                  exact
                  path="/historico-antecipacao"
                  component={AnticipationHistory}
                />
                <PrivateRoute
                  exact
                  path="/detalhe-liquidacao-recebiveis"
                  component={Recebiveis}
                />
                <PrivateRoute
                  exact
                  path="/admin/efeito-contrato"
                  component={ContractEffects}
                />
                <PrivateRoute
                  exact
                  path="/admin/chargeback"
                  component={Chageback}
                />
              </PageWrapperComercial>
            </AuthGateComercial>}

            {userType === 7 && <AuthGateParceiro>
              <PageWrapperParceiro>
                <PrivateRoute exact path="/">
                  <Redirect to="/painel-de-vendas" />
                </PrivateRoute>
                <PrivateRoute exact path="/usuarios" component={Usuarios} />
                <PrivateRoute
                  exact
                  path="/cancelamentos"
                  component={Cancellations}
                />
                <PrivateRoute exact path="/chargebacks" component={Chargeback} />
                <PrivateRoute exact path="/vendas" component={Vendas} />
                <PrivateRoute
                  exact
                  path="/notaPromissoria"
                  component={NotaPromissoria}
                />
                <PrivateRoute
                  exact
                  path="/adiantamentos"
                  component={Adiantamentos}
                />
                <PrivateRoute
                  exact
                  path="/credenciais/criar-credencial"
                  component={Credenciais}
                />
                <PrivateRoute exact path="/empresas" component={Business} />
                {/* /vincular-empresa saiu do portal (B6): o vínculo
                    usuário↔empresa é administrado no VAULT. */}
                <PrivateRoute exact path="/ajustes" component={Adjustment} />
                <PrivateRoute
                  exact
                  path="/painel-de-vendas"
                  component={PainelDeVendas}
                />
                <PrivateRoute
                  exact
                  path="/painel-de-recebiveis"
                  component={PainelDeRecebiveis}
                />
                <PrivateRoute
                  exact
                  path="/painel-de-pagamentos"
                  component={PainelDePagamentos}
                />
                <PrivateRoute
                  exact
                  path="/cadastro-geral/politicas-cobranca/cadastrar"
                  component={CreatePoliticaCobranca}
                />
                <PrivateRoute
                  exact
                  path="/cadastro-geral/politicas-cobranca"
                  component={ListPoliticaCobranca}
                />
                <PrivateRoute
                  exact
                  path="/cadastro-geral/politicas-cobranca/editar/:politicaCobrancaId"
                  component={UpdatePoliticaCobranca}
                />
                <PrivateRoute
                  exact
                  path="/admin/cadastro-geral/politicas-cobranca/business"
                  component={PoliticaCobrancaEmpresa}
                />
                <PrivateRoute
                  exact
                  path="/contas-digitais/politicas-cobrancas"
                  component={PoliticaContaDigitalList}
                />
                <PrivateRoute
                  exact
                  path="/contas-digitais/politicas-cobrancas/cadastrar"
                  component={PoliticaContaDigitalCreate}
                />
                <PrivateRoute
                  exact
                  path="/contas-digitais/politicas-cobrancas/editar/:politicaCobrancaId"
                  component={PoliticaContaDigitalUpdate}
                />
                <PrivateRoute
                  exact
                  path="/simulador/venda"
                  component={SimuladorVenda}
                />
                <PrivateRoute
                  exact
                  path="/simulador/recebimento"
                  component={SimuladorRecebimento}
                />
                <PrivateRoute
                  exact
                  path="/painel-de-depositos"
                  component={PainelDeDepositos}
                />
                <PrivateRoute
                  exact
                  path="/detalhe-liquidacao-recebiveis"
                  component={Recebiveis}
                />
                <PrivateRoute
                  exact
                  path="/admin/efeito-contrato"
                  component={ContractEffects}
                />
                <PrivateRoute
                  exact
                  path="/menu-cobrancas"
                  component={BillingPanel}
                />
                <PrivateRoute exact path="/produtos" component={Signatures} />
                <PrivateRoute
                  exact
                  path="/admin/historico-antecipacao"
                  component={AnticipationHistory}
                />
                <PrivateRoute
                  exact
                  path="/admin/chargeback"
                  component={Chageback}
                />
              </PageWrapperParceiro>
            </AuthGateParceiro>}

            {userType === 8 && <AuthGateContaSplit>
              {business && (
                <>
                  <PrivateRoute exact path="/">
                    <Redirect to="/lista-empresa" />
                  </PrivateRoute>
                  <PrivateRoute
                    exact
                    path="/lista-empresa"
                    component={ListaEmpresa}
                  />
                </>
              )}
              {!business && (
                <PageWrapperContaSplit>
                  <PrivateRoute exact path="/lista-empresa">
                    <Redirect to="/extrato" />
                  </PrivateRoute>
                  <PrivateRoute exact path="/">
                    <Redirect to="/extrato" />
                  </PrivateRoute>

                  <PrivateRoute
                    exact
                    path="/lista-empresa"
                    component={ListaEmpresa}
                  />

                  {selectedBusiness?.splitEnabled && (
                    <PrivateRoute
                      exact
                      path="/extrato"
                      component={PaymentStatement}
                    />
                  )}
                  <PrivateRoute exact path="/meu-perfil" component={MeuPerfil} />
                </PageWrapperContaSplit>
              )}
            </AuthGateContaSplit>}
          </AuthLayout>
        </Route>
        <Route exact path="*" component={NotFound} />
      </Switch>
    </Router>
  );
};

export default Routes;
